interface ValidationResult {
    isValid: boolean;
    message: string;
    safeFileName: string;
    extension: string;
  }
  
  const validateFileName = (file: File, allowedExtensions: string[]): ValidationResult => {
    const parts = file.name.split('.');
    
    if (parts.length <= 1) {
      return { isValid: false, message: "File must have a valid extension", safeFileName: file.name, extension: "" };
    }
    
    const extension = parts[parts.length - 1].toLowerCase();
    const safeFileName = parts.slice(0, -1).join('.');
    const hasDoubleExtension = parts.length > 2;
    
    if (!allowedExtensions.includes(extension)) {
      return {
        isValid: false,
        message: `File type .${extension} is not allowed. Allowed types: ${allowedExtensions.join(', ')}`,
        safeFileName,
        extension
      };
    }
    
    if (hasDoubleExtension) {
      return {
        isValid: false,
        message: "Files with multiple extensions are not allowed",
        safeFileName,
        extension
      };
    }
    
    return { isValid: true, message: "File is valid", safeFileName, extension };
  };
  
  export default validateFileName;
  
  
  